import { apiCallWrapper } from "traveldesk-ui";
import TourMiniDisplayModel from "../models/TourMiniDisplayModel";
export default class ToursApiService {
    public static async getAllMiniDisplay(dispatch: any) {
        return await apiCallWrapper<TourMiniDisplayModel[]>(`/api/tours/options`, 'GET', dispatch)
    }
}